module.exports = "/packs/media/images/avatar-william-dd0c41182756922db87a8d288acaf69e.jpg";